import { useMutation } from '@tanstack/react-query';

import { useAvApi } from '@app-velocity/av-api-v2';

export const usePublishGuestScenarioMutation = (
  workspaceId?: string,
  signal?: AbortSignal
) => {
  const { guestPrototypes } = useAvApi();

  return useMutation({
    mutationKey: ['publish-guest-scenario-mutation'],
    mutationFn: async (prototypeId: string) => {
      if (!workspaceId || !prototypeId) return;

      const res =
        await guestPrototypes.putV2GuestPrototypesByProjectIdAndPrototypeId(
          {
            status: 'PUBLISHED',
          },
          {
            projectId: workspaceId,
            prototypeId,
          },
          { signal }
        );

      return res.data;
    },
  });
};
